import React from 'react';
import { formatDecimal, formatFullDecimal } from 'utils/number';
import {
  PriceInfoContainer,
  PriceDisplayContainer,
  PriceFreightContainer,
} from './PriceInfo.styled';
import { PriceLabel, PriceValue, FreightText } from '../../atoms';

export interface PriceInfoProps {
  price: number;
  unit?: string;
  shipping?: number;
  className?: string;
}

const formatShipping = (shipping: number): string =>
  shipping === 0 ? 'R$ 00,00' : `R$ ${formatFullDecimal(shipping)}`;

export function PriceInfo({
  price,
  unit = 'un',
  shipping = 0,
  className,
}: PriceInfoProps) {
  return (
    <PriceInfoContainer
      className={`price-info ${className ? ` ${className}` : ''}`}
    >
      <PriceDisplayContainer className="price-display">
        <PriceLabel className="price-label">A partir de:</PriceLabel>
        <PriceFreightContainer className="price-container">
          <div className="price-section">
            <PriceValue className="price-value">
              R$ {formatDecimal(price)}
            </PriceValue>{' '}
            {unit}
          </div>
          <div className="freight-section">
            <FreightText className="freight-text">
              Frete: {formatShipping(shipping)}
            </FreightText>
          </div>
        </PriceFreightContainer>
      </PriceDisplayContainer>
    </PriceInfoContainer>
  );
}
